import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import toast from "react-hot-toast";
import { fetchExternalApplications, fetchWalletNotifications } from "../../Apis/Wallet-api";
import { formatDateTime, formatLabel } from "../../Utils/walletFormat";
import WalletPageShell from "../../Components/Wallet/WalletPageShell";

export default function WalletNotificationsPage() {
  const [apps, setApps] = useState([]);
  const [appFilter, setAppFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState({ items: [], pagination: {} });

  const loadApps = useCallback(async () => {
    try {
      const rows = await fetchExternalApplications();
      setApps(Array.isArray(rows) ? rows : []);
    } catch {
      setApps([]);
    }
  }, []);

  const loadLogs = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchWalletNotifications(1, 50, appFilter || undefined);
      setLogs(data || { items: [], pagination: {} });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load notification log.");
    } finally {
      setLoading(false);
    }
  }, [appFilter]);

  useEffect(() => {
    loadApps();
  }, [loadApps]);

  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  return (
    <WalletPageShell
      heading="Notification logs"
      subtitle="Outbound SMS / WhatsApp / email delivery log for wallet events"
    >
      <Stack spacing={2}>
        <FormControl size="small" sx={{ maxWidth: 320 }}>
          <InputLabel>Filter by agent</InputLabel>
          <Select
            label="Filter by agent"
            value={appFilter}
            onChange={(e) => setAppFilter(e.target.value)}
          >
            <MenuItem value="">All agents</MenuItem>
            {apps.map((app) => (
              <MenuItem key={app.id} value={app.id}>
                {app.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>App ID</TableCell>
                  <TableCell>Txn</TableCell>
                  <TableCell>Channel</TableCell>
                  <TableCell>Event</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(logs.items || []).map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.external_application_id}</TableCell>
                    <TableCell>{row.transaction_id || "—"}</TableCell>
                    <TableCell>{row.channel}</TableCell>
                    <TableCell>{row.event}</TableCell>
                    <TableCell>
                      <Chip size="small" label={formatLabel(row.status)} />
                    </TableCell>
                    <TableCell>{formatDateTime(row.created_at)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Stack>
    </WalletPageShell>
  );
}
